import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tozan_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['X-Api-Token'] = `Bearer ${token}`;
    config.headers["X-Token"] = token;
    config.headers["X-Auth-Token"] = token;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("tozan_token");
      localStorage.removeItem("tozan_user");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { BACKEND_URL };
